import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-field", { editing: $setup.editing }]),
    tabindex: "0",
    onClick: _cache[2] || (_cache[2] = $event => (!$setup.editing && $setup.begin())),
    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => (!$setup.editing && $setup.begin()), ["prevent"]), ["enter"]))
  }, [
    ($setup.editing)
      ? (_openBlock(), _createElementBlock("select", {
          key: 0,
          ref: "select",
          value: $props.modelValue ?? '',
          onChange: $setup.finish,
          onBlur: _cache[0] || (_cache[0] = $event => ($setup.editing=false)),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          ($props.allowEmpty)
            ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString($props.placeholder), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.id ?? option.value,
              value: option.id ?? option.value
            }, _toDisplayString(option.name ?? option.label), 9 /* TEXT, PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.current?.name ?? $setup.current?.label ?? $props.placeholder), 1 /* TEXT */))
  ], 34 /* CLASS, NEED_HYDRATION */))
}